import { FetchError } from "../errors/FetchError";
import { fetchWithAuthorization } from "./fetch";

export const fetchAccountingAreas = async (condominiumId) => {
    try {
        const data = await fetchWithAuthorization(`/finances/accounting-areas?condominium_id=${condominiumId}`);
        return data;
    } catch (error) {
        throw new FetchError(error, "Http call to fetch accounting areas failed");
    }
};

export const createAccountingArea = async (params) => {
    try {
        const data = await fetchWithAuthorization(`/finances/accounting-areas`, params, 'POST');
        return data;
    } catch (error) {
        throw new FetchError(error, "Http call to create accounting area failed");
    }
};

export const updateAccountingArea = async (id, params) => {
    try {
        const data = await fetchWithAuthorization(`/finances/accounting-areas/${id}`, params, 'PUT');
        return data;
    } catch (error) {
        throw new FetchError(error, "Http call to update accounting area failed");
    }
};

export const deleteAccountingArea = async (id) => {
    try {
        const data = await fetchWithAuthorization(`/finances/accounting-areas/${id}`, null, 'DELETE');
        return data;
    } catch (error) {
        throw new FetchError(error, "Http call to delete accounting area failed");
    }
};
